var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import DataCacheService from '@/shared/services/DataCacheService';
import AuthService from '../services/AuthService';
export var DataContext = React.createContext(null);
export var useDataContext = function () {
    var ctx = useContext(DataContext);
    if (!ctx) {
        throw new Error('Wrap app with DataProvider');
    }
    return ctx;
};
var DataProvider = function (_a) {
    var children = _a.children;
    var getUsers = useMemo(function () { return DataCacheService.getUsers(); }, []);
    var getDefaultCompany = useMemo(function () { return DataCacheService.getDefaultCompany(); }, []);
    var getCurrentUserId = useMemo(function () { return AuthService.getUserId(); }, []);
    var getUserLanguage = useMemo(function () { return DataCacheService.getUserLanguage(getCurrentUserId); }, [
        getCurrentUserId,
    ]);
    var getCompanies = useMemo(function () { return DataCacheService.getCompanies(); }, []);
    var getAllCompanies = useMemo(function () { return DataCacheService.getAllCompanies(); }, []);
    var value = useMemo(function () { return ({
        users: getUsers,
        defaultCompany: getDefaultCompany,
        currentUserId: getCurrentUserId,
        userLanguage: getUserLanguage,
        companies: getCompanies,
        allCompanies: getAllCompanies,
    }); }, [getDefaultCompany, getUsers, getCurrentUserId, getUserLanguage, getCompanies, getAllCompanies]);
    return _jsx(DataContext.Provider, __assign({ value: value }, { children: children }));
};
export default DataProvider;
